import styled from 'styled-components';

const PageWrapper = styled.div<{ isTablet: boolean; isMobile: boolean; insidePage: boolean }>`
  width: 100%;
  max-width: ${(p) => (p.insidePage ? 'unset' : '1620px')};
  margin: ${(p) => (p.insidePage ? '0 auto' : '0 auto')};
  padding: ${(p) => (!p.insidePage && p.isMobile ? '40px 20px' : !p.insidePage && p.isTablet ? '60px 30px' : p.insidePage && p.isMobile ? '20px 30px 60px' : p.insidePage && p.isTablet ? '20px 60px 60px' : p.insidePage ? '20px 60px 60px 300px' : '70px 80px')};
  background: ${(p) => (p.insidePage ? '#f5f5f5' : 'transparent')};
`;

const BannerWrapper = styled.div<{ isTablet: boolean; isMobile: boolean }>`
  width: 100%;
  margin: 0 auto;
  margin-bottom: ${(p) => (p.isMobile ? '30px' : '60px')};
  position: relative;
  background: linear-gradient(90deg, #0f319d 0%, #4ebbc6 100%);
  border-radius: 40px 40px 40px 0px;
  filter: drop-shadow(7px 7px 15px rgba(0, 0, 0, 0.2));
  overflow: hidden;

  img {
    width: 100%;
    object-fit: cover;
  }
`;

const TitleSection = styled.div<{ isMobile: boolean; isTablet: boolean }>`
  text-align: center;
  margin-bottom: ${(p) => (p.isMobile ? '30px' : '60px')};
`;

const MainTitle = styled.h1<{ isMobile: boolean }>`
  font-family: 'Roboto', sans-serif;
  font-size: 34px;
  font-weight: 700;
  line-height: ${(p) => (p.isMobile ? '34px' : '50px')};
  color: ${(p) => p.theme.colors.gray500};
`;

const TabButtonGroup = styled.div<{ isMobile: boolean; isTablet: boolean }>`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: ${(p) => (p.isMobile ? '30px' : '60px')};
`;

const TabButton = styled.button<{ active: boolean; isMobile: boolean }>`
  padding: ${(p) => (p.isMobile ? '7px 20px' : '7px 30px')};
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  line-height: 23px;
  color: ${(p) => p.theme.colors.light};
  background-color: ${(p) =>
    p.active ? p.theme.colors.secondary400 : p.theme.colors.gray200};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  min-width: ${(p) => (p.isMobile ? '100%' : '200px')};
  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }
`;

const LinkButton = styled.a<{ isMobile: boolean }>`
  display: inline-block;
  padding: ${(p) => (p.isMobile ? '12px 20px' : '15px 30px')};
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  line-height: 23px;
  color: ${(p) => p.theme.colors.light};
  background-color: ${(p) => p.theme.colors.primary500};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  min-width: ${(p) => (p.isMobile ? '100%' : '200px')};
  text-align: center;

  &:hover {
    filter: brightness(1.1);
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1000px;
`;

const ContentTitle = styled.h3<{ isMobile: boolean, textAlign?: string }>`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.lg};
  font-weight: 700;
  line-height: 51px;
  color: ${(p) => p.theme.colors.primary500};
  text-align: ${(p) => p.textAlign || 'left'};  
`;

const ContentSubtitle = styled.h4`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  line-height: 30px;
  color: ${(p) => p.theme.colors.gray500};
  margin-bottom: 20px;
  text-align: center;
`;

const ContentSection = styled.div<{ isMobile: boolean }>`
  margin-bottom: ${(p) => (p.isMobile ? '40px' : '80px')};

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionContent = styled.div<{ isMobile: boolean, textAlign?: string }>`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.base};
  font-weight: 400;
  line-height: 30px;
  color: ${(p) => p.theme.colors.gray500};
  text-align: ${(p) => p.textAlign || 'left'};  
`;

const ImagePlaceholder = styled.div<{ isMobile: boolean; isTablet: boolean }>`
  width: 100%;
  height: ${(p) => (p.isMobile ? '200px' : p.isTablet ? '300px' : '400px')};
  background-color: ${(p) => p.theme.colors.gray100};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.colors.gray300};
  margin-bottom: 20px;
`;

const CardGrid = styled.div<{ isMobile: boolean; isTablet: boolean, gridRepeat?: string, gridGap?: string }>`
  display: grid;
  grid-template-columns: ${(p) => p.gridRepeat};
  gap: ${(p) => (p.gridGap)};
  margin-top: 30px;
  padding: ${(p) => (p.isMobile ? '20px' : '20px 80px')};
`;

const CardIcon = styled.div<{ isMobile: boolean }>`
  width: 180px;
  margin: 0 auto 12px;
`;

const CardTitle = styled.h5<{ isMobile: boolean }>`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => (p.isMobile ? '16px' : '20px')};
  font-weight: 700;
  line-height: ${(p) => (p.isMobile ? '24px' : '30px')};
  color: ${(p) => p.theme.colors.gray500};
  margin-bottom: 10px;
  text-align: center;
`;

const CardDescription = styled.p<{ isMobile: boolean }>`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.base};
  font-weight: 400;
  line-height: 25px;
  color: ${(p) => p.theme.colors.gray400};
`;

const GradientCardGrid = styled.div<{ isMobile: boolean; isTablet: boolean, gridRepeat?: string, gridGap?: string }>`
  display: grid;
  grid-template-columns: ${(p) => p.gridRepeat};
  gap: ${(p) => (p.gridGap)};
`;


const GradientCard = styled.div<{ isMobile: boolean, padding?: string }>`
  background: linear-gradient(90deg, #0f319d 0%, #4ebbc6 100%);
  padding: ${(p) => p.padding ? p.padding : '20px'};
  border-radius: 40px 40px 40px 0px;
  color: ${(p) => p.theme.colors.light};
`;

const GradientCardTitle = styled.h5<{ isMobile: boolean, fontSize?: string, textAlign?: string }>`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => (p.fontSize ? p.fontSize : p.theme.fontSizes.md)};
  font-weight: 700;
  line-height: ${(p) => (p.fontSize ? `calc(${p.fontSize} * 1.6)` : '32px')};
  text-align: ${(p) => (p.textAlign ? p.textAlign : 'left')};
`;

const GradientCardDescription = styled.p<{ isMobile: boolean; lineHeight?: string }>`
  font-size: ${(p) => p.theme.fontSizes.base};
  font-weight: 400;
  line-height: ${(p) => p.lineHeight ? p.lineHeight : '25px'};
`;

const FeatureCardItems = styled.div<{ isMobile: boolean }>`
  display: grid;
  grid-template-columns: ${(p) => (p.isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))')};
  column-gap: 40px;
  row-gap: 20px;
`;

const Hr = styled.hr`
  width: 100%;
  border: 1px solid #fff;
  margin: 10px 0;
`

const RadioTable = styled.ol`
  list-style: none;

  li {
    display: flex;
    gap: 16px;
    align-items: center;
    padding: 22px 20px;
    border-top: 2px solid ${(p) => p.theme.colors.gray100};
  }

  li:nth-child(odd) {
    background-color: ${(p) => p.theme.colors.gray000};
  }
    
  li:nth-child(even) {
    background-color: ${(p) => p.theme.colors.light};
  }

  li:last-child {
    border-bottom: 2px solid ${(p) => p.theme.colors.gray100};
  }
`

export {
  PageWrapper,
  BannerWrapper,
  TitleSection,
  MainTitle,
  TabButtonGroup,
  TabButton,
  LinkButton,
  ContentWrapper,
  ContentTitle,
  ContentSubtitle,
  ContentSection,
  SectionContent,
  ImagePlaceholder,
  CardGrid,
  CardIcon,
  CardTitle,
  CardDescription,
  GradientCardGrid,
  GradientCard,
  GradientCardTitle,
  GradientCardDescription,
  FeatureCardItems,
  Hr,
  RadioTable
};
